
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { BarChart, Bar, XAxis, YAxis, CartesianGrid, ResponsiveContainer } from 'recharts';
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@/components/ui/chart";

interface GameActivityChartProps {
  data: Array<{
    name: string;
    games: number;
    sos: number;
  }>;
}

const GameActivityChart = ({ data }: GameActivityChartProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Game Activity</CardTitle>
        <CardDescription>
          Your game sessions and SOS events over time
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="h-[300px]">
          <ChartContainer
            config={{
              games: {
                label: "Game Sessions",
                color: "#8BAF96", // sage
              },
              sos: {
                label: "SOS Events",
                color: "#FF9A8B", // coral
              },
            }}
          >
            <ResponsiveContainer width="100%" height="100%">
              <BarChart
                data={data}
                margin={{ top: 20, right: 30, left: 0, bottom: 5 }}
              >
                <CartesianGrid strokeDasharray="3 3" />
                <XAxis dataKey="name" />
                <YAxis />
                <Bar dataKey="games" stackId="a" fill="var(--color-games)" />
                <Bar dataKey="sos" stackId="a" fill="var(--color-sos)" />
                <ChartTooltip
                  content={
                    <ChartTooltipContent
                      nameKey="name"
                    />
                  }
                />
              </BarChart>
            </ResponsiveContainer>
          </ChartContainer>
        </div>
      </CardContent>
    </Card>
  );
};

export default GameActivityChart;
